import { Box, Button, FormGroup, TextField } from "@mui/material";
import SimpleDialog from "../../common/SimpleDialog";
import { Filter } from "../../filters/FilterTypes";
import Filters from "../../filters/leads/Filters";
import CloseIcon from '@mui/icons-material/Close'
import SaveAltIcon from '@mui/icons-material/SaveAlt'
import { useEffect, useState } from "react";
import { PlaybookStore } from "../PlaybookStore";
import { client } from "../../../utils/axios-client";
import { ApiResponseType } from "../../../types";
import _ from "lodash";

type Props = {
    open: boolean,
    onClose: () => void,
    filter: Filter
}

const EditPlaybookFilter = ({ open, onClose, filter }: Props) => {
    const selectedVariant = PlaybookStore.useState(s => s.selectedTemplateVariant);
    const [internalFilter, setInternalFilter] = useState(filter);
    const [hasError, setHasError] = useState<boolean>(false);

    useEffect(() => {
        setInternalFilter(filter);
        setHasError(false);
    }, [filter])

    const onChange = (updatedFilter: Filter) => {
        setInternalFilter(updatedFilter);
    }

    const onSave = async () => {
        setHasError(false);

        if (_.isEmpty(internalFilter.description)) {
            setHasError(true);
            return;
        }

        const response = await client.post<ApiResponseType>('/api/leadfilters/cadence-template', { filter: internalFilter, variantId: selectedVariant?.id });

        if (response.data.succeeded) {
            onClose();
        } else {
            alert('error saving template');
        }
    }

    return <SimpleDialog open={open} onClose={onClose} title=''>
        <FormGroup sx={{ mb: 1 }}>
            <TextField size="small" label="Filter Name" placeholder="Enter Filter Name" value={internalFilter.description} onChange={(e) => setInternalFilter({ ...internalFilter, description: e.target.value })} />
            {hasError && <span style={{ color: 'red' }}>Please enter a description for the filter</span>}
        </FormGroup>
        <Filters onFiltersChanged={onChange} filter={internalFilter} />

        <Box sx={{ textAlign: 'right' }}>
            <Button sx={{ mb: 2, mr: 2 }} variant='contained' onClick={onClose} startIcon={<CloseIcon />} size="small">
                Close
            </Button>
            <Button sx={{ mb: 2 }} variant='contained' onClick={onSave} startIcon={<SaveAltIcon />} size="small">
                Save
            </Button>
        </Box>
    </SimpleDialog>
}

export default EditPlaybookFilter;